export default __webpack_public_path__ + "static/media/paintbrush.4a5c788c.svg";